import { AgResourceLanguage } from '../types';
import { orderList as EnUsOrderList } from '../en-us/orderList';

export const orderList: AgResourceLanguage['orderList'] = {
  ...EnUsOrderList,
  filterOrders: {
    filterTitle: 'Mostrar pedidos para:',
    filterOptionTitle: 'Todas las Suscripciones'
  },
  emptyPastOrders: {
    title: `Aún no tienes pedidos`,
    description: 'Comienza a comprar y vuelve a revisar esta página más tarde.',
    buttonName: 'Obtén tu AG1'
  },
  emptyUpcomingOrders: {
    title: 'No tienes pedidos próximos',
    buttonName: 'Obtén tu AG1'
  },
  upcomingOrders: {
    title: 'Próximos Pedidos',
    card: {
      orderDateLabel: 'Fecha de Pedido',
      subscriptionNameLabel: 'Suscripción',
      subscriptionStatusLabel: 'Estado',
      unpaidStatus: 'No Pagado',
      totalAmountLabel: 'Total',
      shipButton: 'Enviar Ahora',
      editDetailsButton: 'Editar Detalles',
      skipShipmentButton: 'Omitir Envío'
    }
  },
  pastOrders: {
    title: 'Pedidos',
    table: {
      idPreSymbol: '#',
      orderNumberColumn: 'Número de Pedido',
      dateColumn: 'Fecha',
      subscriptionNameColumn: 'Suscripción',
      statusColumn: 'Estado',
      totalColumn: 'Total',
      trackButton: 'Rastrear Pedido',
      oneTimeLabel: 'Compra Única'
    },
    card: {
      idPreSymbol: '#',
      orderLabel: 'Pedido',
      dateLabel: 'Fecha:',
      subscriptionLabel: 'Suscripción',
      statusLabel: 'Estado',
      totalLabel: 'Total',
      trackButtonMobile: 'Rastrear Pedido',
      trackButtonTablet: 'Rastrear Pedido',
      viewDetailsButton: 'Ver Detalles'
    }
  }
};
